module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kbfg.b9020f42239bb3b59a251b601037352b.png";